export function getExternalLinkHref(link?: string, suffix?: string) {
  const href = `${link}${suffix}`;
  return href;
}
